import { Component, OnInit, TemplateRef, Input, ChangeDetectorRef } from '@angular/core';
/*import { NgDragDropModule, DropEvent } from 'ng-drag-drop';*/
import { Router, ActivatedRoute, Params } from '@angular/router';
import { IExchangeProperties } from '../../shared/models/ExchangePropertiesOutputModel';
import { Trade1031Service } from '../../shared/providers/Trade1031.service';
import { IExchangePropertyStatusInputModel, IPortfolioNameInput, IMovePortfolioGroupIModel } from '../../shared/models/ExchangePropertyStatusInputModel';
import { ValidationService } from '../../shared/providers/validation.service';
import { IExchangeCodeOutputModel, IExchangeDetailsputModel } from '../../shared/models/ExchangeCodeOutputModel';
import { AuthenticationService } from '../../shared/auth/authentication.service'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../shared/providers/toast.service'
import { SharedService } from '../../shared/providers/shared.service';
import { ArrayFilterPipe } from '../../shared/pipes/array-filter.pipe';
import { LoaderService } from '../../shared/providers/loader.service';
import { ComparePropertiesModel } from '../../shared/models/ComparePropertiesModel';
import { ComparisonService } from '../../shared/providers/comparison.service';
import { BreadCrumbInput } from '../../shared/models/BreadCrumbInputModel';
import { IDashboardOModel, IExchangeInvites, IExchangeInvitesList } from '../../shared/models/DashboardDataOModel';
import { CommonService } from '../../shared/providers/common.service';
import { IPropertyChatModel } from '../../shared/models/PropertyChatModel';
import {
  CdkDragDrop,
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';

export enum tables {
  suggested = 2200,
  wishlist = 2201,
  analysis = 2202,
  portfolio = 2203,
  Pendingoffer = 1,
  OfferAccepted = 460,
  UnderContract = 455,
  HardContract = 462,
  Closed = 456
}

export enum view {
  List = 1,
  Grid = 2
}

export enum Actions {
  Select = 0,
  Delete = 1,
  Compare = 2,
  ViewStatitics = 3
}

class PortfolioName {
  Id: number;
  Name: string;
  Category: number;
}

@Component({
  selector: 'app-1031-portfolio',
  templateUrl: './1031-portfolio.component.html',
  styleUrls: ['./1031-portfolio.component.css']

})
export class User1031PortfolioComponent implements OnInit {
  constructor(private trade1031Service: Trade1031Service, private _ValidationService: ValidationService, private router: Router, public comparisonService: ComparisonService,
    public authService: AuthenticationService, private modalService: BsModalService, private Toast: ToastService, private Shared: SharedService,
    private Loader: LoaderService, private changeRef: ChangeDetectorRef, public commonService: CommonService,) {

    this.comparisonService.isComparePage = false;
  }
  html: string = `<span class="btn btn-danger">Never trust not sanitized HTML!!!</span>`;
  @Input() exchangeSelected: number = 0;
  @Input() breadCrumbInput: BreadCrumbInput = null;
  BreadCrumb = {} as BreadCrumbInput;
  @Input() activeTab: string = null;
  currentDragTable = tables.suggested;
  tables = tables;
  Views = view;
  user: any;
  isUserLoggedIn = false;
  showSuggestButton: boolean = false;
  showSuggestList: boolean = false;
  showStarRating: boolean = false;
  suggested = [];
  wishlist = [];
  portfolio = [];
  analysis = [];
  analysisGropList = [];
  portfolioGropList = [];

  analysisGroup = [];
  portfolioGroup = [];

  dragEnabled = true;
  suggestedcount = 0;
  wishlistcount = 0;
  portfoliocount = 0;
  analysiscount = 0;

  view = view.List;

  StatusInputModel = {} as IExchangePropertyStatusInputModel;
  outputResponse: IExchangeProperties[];
  offersResponse: IExchangeProperties[];
  outputResponseFiltered: IExchangeProperties[];
  exchangeCodes: IExchangeCodeOutputModel[];
  exchangeDetails = {} as IExchangeDetailsputModel;
  portfolioName = {} as IPortfolioNameInput;
  MovePortfolioGroupIModel = {} as IMovePortfolioGroupIModel;
  comparePropertiesModel = {} as ComparePropertiesModel;

  portfolioNameList: IPortfolioNameInput[];
  propertyChatModel = {} as IPropertyChatModel;

  selectedExchange: number = 0;
  selectedAction = 0;
  searchString = '';
  popupheading = "Property";
  noDataOnPageLoad = true;
  isAnalyzeCheck: boolean = false;

  blockDataReload = true;
  callFromComponent = false;
  modalRef: BsModalRef;

  showDashboard = false;
  portfolioTileList: IDashboardOModel[];
  //colors = ["#28A436", "#EC5555", "#F2BD66", "#5BC8AF", "#198fde", "#8647B3", "#e47220"];
  portfolioListCount = 0;
  haveaccesstoviewlocation: boolean = true;
  portfolioList: IExchangeProperties[];
  portfolioListCopy: IExchangeProperties[];
  portfolioListForSearch: IExchangeProperties[];
  isSuggestedOrFavorites: boolean = false;
  isPendingOffer: boolean = false;
  isUnderContractOrOthers: boolean = false;
  isviewAll: boolean = true;
  viewActions: boolean = true;
  selectedPropertyGuid = "";
  isPropertyAnalysis: false;


  //@Output() propertySuggested = new EventEmitter();

  setBreadCrumb() {
    if (this.BreadCrumb === null) {
      const BC =
      {
        PrevPageName: "Pipeline",
        PrevPageLink: "portfolio-1031"
      }
      this.BreadCrumb = BC;
    }
    else {
      this.BreadCrumb.PrevPageName = this.breadCrumbInput.PrevPageName;
      this.BreadCrumb.PrevPageLink = this.breadCrumbInput.PrevPageLink;
      this.BreadCrumb.AdditionalLinkParams = this.breadCrumbInput.AdditionalLinkParams;
      if (this.activeTab !== null && this.activeTab !== undefined) {
        this.BreadCrumb.PrevPageLink += "?tab=" + this.activeTab;
      }
    }
  }

  todo = ['Get to work', 'Pick up groceries', 'Go home', 'Fall asleep'];

  done = ['Get up', 'Brush teeth', 'Take a shower', 'Check e-mail', 'Walk dog'];

  drop(event: any, DropTo: number, PortfolioNameId?: number) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      this.StatusInputModel.Id = Number(event.container.data[event.currentIndex].Id);
      this.StatusInputModel.DropTo = DropTo;
      this.StatusInputModel.PortfolioNameId = PortfolioNameId;
      this.StatusInputModel.loggedInUserID = this.user.Id;
      this.ChangeStatus(event);
    }
  }


  ngOnInit() {
    this.setBreadCrumb();
    this.user = this.authService.user != null ? this.authService.user : "";
    if (!this.authService.Admin() && !this.authService.Broker() && !this.authService.DataEntryStaff() && !this.authService.SuperAdmin()) {
      this.haveaccesstoviewlocation = false;
    }
    else {
      this.haveaccesstoviewlocation = true;
    }
    this.comparisonService.isComparePage = false;
    if (!this._ValidationService.IsinValid(this.exchangeSelected) && this.exchangeSelected > 0) {
      this.callFromComponent = true;
      this.selectedExchange = this.exchangeSelected;
      if (!this.callFromComponent) { this.Loader.display(true) };
      if (this.selectedExchange > 0) {
        this.loadPortfolioData();
      }
      else { if (!this.callFromComponent) { this.Loader.display(false) }; }
    }
    //Below code will execute when 1031 user changes his current 1031 exchange from 1031-exchange-selector component
    this.Shared.exchangeSelection.subscribe(res => {
      if (!this.callFromComponent) { this.Loader.display(true) };
      if (res > 0) {
        this.selectedExchange = res;
      }
      if (this.selectedExchange > 0 && this.blockDataReload) {
        this.loadPortfolioData();
      }
      else { if (!this.callFromComponent) { this.Loader.display(false) } }
      this.blockDataReload = true;
    });

    this.selectedAction = 0;

    this.authService.isLoggedIn.subscribe(response => {
      this.isUserLoggedIn = response;
      if (this.isUserLoggedIn) {
        if (this.authService.Broker()) {
          this.showSuggestButton = true;
        }
        else {
          this.showSuggestButton = false;
        }
        if (this.authService.Broker() || this.authService.Principal1031()) {
          this.showStarRating = true;
        }
        else {
          this.showStarRating = false;
        }
      }
    });
  }
  loadPortfolioData() {
    this.Loader.display(true);
    this.blockDataReload = false;
    this.comparePropertiesModel.Exchange1031Id = this.selectedExchange;
    this.comparePropertiesModel.PropertyIds = [];
    this.loadExchangeDetails();
    this.loadPortfolioNameList();
    this.loadData();
    this.loadPortfolioTileData();
    this.loadPortfolioList();

  }

  loadPortfolioTileData() {
    this.trade1031Service.GetDashboardData(this.selectedExchange).subscribe(res => {
      this.portfolioTileList = res;
      this.showDashboard = true;
    });
  }

  loadPortfolioList(applyFilter: boolean = false) {
    this.trade1031Service.GetPortfolioList(this.selectedExchange, this.user.Id).subscribe(res => {
      this.portfolioList = res;
      this.portfolioListCopy = res;
      this.portfolioListForSearch = res;
      let data = this.portfolioListCopy;

      if (this.portfolioList.length > 0) {
        this.noDataOnPageLoad = false;
        this.portfolioListCount = this.portfolioList.length;
      }
      else {
        this.noDataOnPageLoad = true;
      }

      var favoritesPrice = 0;
      var suggestedPrice = 0;
      var pendingOfferPrice = 0;
      var offerAcceptedPrice = 0;
      var hardContractPrice = 0;
      var underContractPrice = 0;
      var closedPrice = 0;
      var cancelledPrice = 0;


      this.portfolioList.forEach(item => {
        if (item.OfferPlaced != 460 && item.OfferPlaced != 455 && item.OfferPlaced != 462 &&
          item.OfferPlaced != 456 && item.OfferPlaced != 457 && item.OfferPlaced != 464
          && item.OfferPlaced != 467 && item.OfferPlaced != 466 && item.GroupId == 2203 && item.OfferPlaced != null && item.OfferPlaced>0) {
          item.Title = "Pending Offer";
          if (item.OfferPlaced == 0) {
            pendingOfferPrice = pendingOfferPrice + item.Price;
          }
          else {
            pendingOfferPrice = pendingOfferPrice + item.OfferPrice;
          }
        }
        else if (item.OfferPlaced == 460 && item.OfferExchangeId != 0 && item.OfferExchangeId != null) {
          item.Title = "Offer Accepted";
          offerAcceptedPrice = offerAcceptedPrice + item.OfferPrice;
        }
        else if ((item.OfferPlaced == 462) && item.OfferExchangeId != 0 && item.OfferExchangeId != null) {
          item.Title = "Hard Contract";
          hardContractPrice = hardContractPrice + item.OfferPrice;
        }
        else if (item.OfferPlaced == 455 && item.OfferExchangeId != 0 && item.OfferExchangeId != null) {
          item.Title = "Under Contract";
          underContractPrice = underContractPrice + item.OfferPrice;
        }
        else if ((item.OfferPlaced == 466 || item.OfferPlaced == 467) && item.OfferExchangeId != 0 && item.OfferExchangeId != null) {
          item.Title = "Declined/Cancelled";
          cancelledPrice = cancelledPrice + item.OfferPrice;
        }
        else if (item.OfferPlaced == 456 && item.OfferExchangeId != 0 && item.OfferExchangeId != null) {
          item.Title = "Closed";
          closedPrice = closedPrice + item.OfferPrice;
        }
        //else if (item.OfferPlaced == 467 && item.OfferExchangeId != 0 && item.OfferExchangeId != null) {
        //  item.Title = "Declined";
        //  closedPrice = closedPrice + item.OfferPrice;
        //}
        else if (item.OfferPlaced != 0 && item.OfferExchangeId != 0 && item.OfferExchangeId != null) {
          item.Title = "Pending Offer";
          //pendingOfferPrice = pendingOfferPrice + item.OfferPrice;
        }
        else if (item.GroupId == 2201 && item.OfferPlaced == 0) {
          favoritesPrice = favoritesPrice + item.Price;
        }
        else if (item.GroupId == 2200 && item.OfferPlaced == 0) {
          suggestedPrice = suggestedPrice + item.Price;
        }

        item.RatingToShow = this.setRating(item.StarRating);
      });


      this.portfolioTileList[0].Title = "Suggested";
      this.portfolioTileList[0].Price = suggestedPrice;
      this.portfolioTileList[0].Count = data.filter(item => item.GroupId == 2200 && item.OfferPlaced == 0).length;
      this.portfolioTileList[0].Color = " #198FDE ";

      this.portfolioTileList[1].Title = "Favorites";
      this.portfolioTileList[1].Price = favoritesPrice;
      this.portfolioTileList[1].Count = data.filter(item => item.GroupId == 2201 && item.OfferPlaced == 0).length;
      this.portfolioTileList[1].Color = " #003A5D ";

      this.portfolioTileList[2].Title = "Pending Offer";
      this.portfolioTileList[2].Price = pendingOfferPrice;
      this.portfolioTileList[2].Count = data.filter(item => (item.OfferPlaced != 460 && item.OfferPlaced != 455 && item.OfferPlaced != 462 &&
        item.OfferPlaced != 456 && item.OfferPlaced != 457 && item.OfferPlaced != 464 && item.GroupId == 2203 && item.OfferPlaced != 467 && item.OfferPlaced != 466 && item.OfferPlaced != null && item.OfferPlaced >0)).length;
      this.portfolioTileList[2].Color = " #A7A8A9 ";

      this.portfolioTileList[3].Title = "Offer Accepted";
      this.portfolioTileList[3].Price = offerAcceptedPrice;
      this.portfolioTileList[3].Count = data.filter(item => item.OfferPlaced == 460 && item.OfferExchangeId != 0 && item.OfferExchangeId != null).length;
      this.portfolioTileList[3].Color = " #02C29F ";

      this.portfolioTileList[4].Title = "Under Contract";
      this.portfolioTileList[4].Price = underContractPrice;
      this.portfolioTileList[4].Count = data.filter(item => item.OfferPlaced == 455 && item.OfferExchangeId != 0 && item.OfferExchangeId != null).length;
      this.portfolioTileList[4].Color = " #59595B ";

      this.portfolioTileList[5].Title = "Hard Contract";
      this.portfolioTileList[5].Price = hardContractPrice;
      this.portfolioTileList[5].Count = data.filter(item => (item.OfferPlaced == 462) && item.OfferExchangeId != 0 && item.OfferExchangeId != null).length;
      this.portfolioTileList[5].Color = " #FFC32B ";

      this.portfolioTileList[6].Title = "Closed";
      this.portfolioTileList[6].Price = closedPrice;
      this.portfolioTileList[6].Count = data.filter(item => item.OfferPlaced == 456 && item.OfferExchangeId != 0 && item.OfferExchangeId != null).length;
      this.portfolioTileList[6].Color = " #FF4438 ";

      this.portfolioTileList[7].Title = "Declined/Cancelled";
      this.portfolioTileList[7].Price = cancelledPrice;
      this.portfolioTileList[7].Count = data.filter(item => (item.OfferPlaced == 466 || item.OfferPlaced == 467) && item.OfferExchangeId != 0 && item.OfferExchangeId != null).length;
      this.portfolioTileList[7].Color = " #e47220 ";

      if (applyFilter) {
        this.tileFilterClick(this.currentTile);
      }

      this.Loader.display(false);
    });

  }

  setRating(value) {
    var starList: number[] = [];
    let i = 1;
    for (i = 1; i <= 5; i++) {
      if (i <= value) {
        starList.push(1);
      }
      else {
        starList.push(0);
      }
    }
    return starList;
  }
  currentTile = "View All";
  tileFilterClick(title) {
    this.searchString = null;
    let data = this.portfolioListCopy;
    let result = [];
    this.currentTile = title;
    this.portfolioTileList[0].isActive = false;
    this.portfolioTileList[1].isActive = false;
    this.portfolioTileList[2].isActive = false;
    this.portfolioTileList[3].isActive = false;
    this.portfolioTileList[4].isActive = false;
    this.portfolioTileList[5].isActive = false;
    this.portfolioTileList[6].isActive = false;
    this.portfolioTileList[7].isActive = false;
    /*  this.portfolioTileList[6].isActive = false;*/
    this.viewActions = false;
    if (title == "Favorites") {
      let filterdItems = data.filter(it => it.GroupId == 2201 && it.OfferPlaced == 0);
      if (filterdItems.length > 0) {
        result = filterdItems;
      }

      this.portfolioTileList[1].isActive = true;
      this.isSuggestedOrFavorites = true;
      this.isPendingOffer = false;
      this.isUnderContractOrOthers = false;
      this.isviewAll = false;
      this.viewActions = true;
    }
    else if (title == "Suggested") {
      let filterdItems = data.filter(it => it.GroupId == 2200 && it.OfferPlaced == 0);
      if (filterdItems.length > 0) {
        result = filterdItems;
      }
      this.isSuggestedOrFavorites = true;
      this.isPendingOffer = false;
      this.isUnderContractOrOthers = false;
      this.isviewAll = false;
      this.viewActions = true;
      this.portfolioTileList[0].isActive = true;
    }
    else if (title == "Offer Accepted") {
      let filterdItems = data.filter(it => it.OfferPlaced == 460 && it.OfferExchangeId != 0 && it.OfferExchangeId != null);
      if (filterdItems.length > 0) {
        result = filterdItems;
      }

      this.isSuggestedOrFavorites = false;
      this.isPendingOffer = true;
      this.isUnderContractOrOthers = false;
      this.isviewAll = false;
      this.portfolioTileList[3].isActive = true;
    }
    else if (title == "Pending Offer") {
      let filterdItems = data.filter(item => (item.OfferPlaced != 460 && item.OfferPlaced != 455 && item.OfferPlaced != 462 &&
        item.OfferPlaced != 456 && item.OfferPlaced != 457 && item.OfferPlaced != 464 && item.GroupId == 2203 && item.OfferPlaced != 467 && item.OfferPlaced != 466 && item.OfferPlaced!=null && item.OfferPlaced > 0));
      if (filterdItems.length > 0) {
        result = filterdItems;
      }

      this.isSuggestedOrFavorites = false;
      this.isPendingOffer = true;
      this.isUnderContractOrOthers = false;
      this.isviewAll = false;
      this.portfolioTileList[2].isActive = true;
    }
    else if (title == "Under Contract") {
      let filterdItems = data.filter(it => it.OfferPlaced == 455 && it.OfferExchangeId != 0 && it.OfferExchangeId != null);
      if (filterdItems.length > 0) {
        result = filterdItems;
      }
      this.isSuggestedOrFavorites = false;
      this.isPendingOffer = false;
      this.isUnderContractOrOthers = true;
      this.isviewAll = false;
      this.portfolioTileList[4].isActive = true;
    }
    else if (title == "Hard Contract") {
      let filterdItems = data.filter(it => (it.OfferPlaced == 462) && it.OfferExchangeId != 0 && it.OfferExchangeId != null);
      if (filterdItems.length > 0) {
        result = filterdItems;
      }
      this.isSuggestedOrFavorites = false;
      this.isPendingOffer = false;
      this.isUnderContractOrOthers = true;
      this.isviewAll = false;
      this.portfolioTileList[5].isActive = true;
    }
    else if (title == "Declined/Cancelled") {
      let filterdItems = data.filter(it => (it.OfferPlaced == 466 || it.OfferPlaced == 467) && it.OfferExchangeId != 0 && it.OfferExchangeId != null);
      if (filterdItems.length > 0) {
        result = filterdItems;
      }
      this.isSuggestedOrFavorites = false;
      this.isPendingOffer = false;
      this.isUnderContractOrOthers = true;
      this.isviewAll = false;
      this.portfolioTileList[7].isActive = true;
    }
    else if (title == "Closed") {
      let filterdItems = data.filter(it => it.OfferPlaced == 456 && it.OfferExchangeId != 0 && it.OfferExchangeId != null);
      if (filterdItems.length > 0) {
        result = filterdItems;
      }
      this.isSuggestedOrFavorites = false;
      this.isPendingOffer = false;
      this.isUnderContractOrOthers = true;
      this.isviewAll = false;
      this.portfolioTileList[6].isActive = true;
    }
    else if (title == "View All") {
      result = data;
      this.isSuggestedOrFavorites = false;
      this.isPendingOffer = false;
      this.isUnderContractOrOthers = false;
      this.isviewAll = true;
    }
    this.portfolioList = [];
    this.portfolioListForSearch = [];
    this.portfolioList = result;
    this.portfolioListForSearch = result;
  }

  onSearch() {

    if (this.searchString.trim().length > 0) {
      // let data = this.portfolioListCopy;
      let data = this.portfolioListForSearch;
      let result = [];

      let filterdItems = data.filter(it => it.PropertyName.toLowerCase().includes(this.searchString.toLowerCase()) || it.Title.toLowerCase().includes(this.searchString.toLowerCase()) || it.Price.toString().includes(this.searchString));
      if (filterdItems.length > 0) {
        result = filterdItems;
      }
      this.portfolioList = [];
      this.portfolioList = result;
    }
    else {
      this.portfolioList = [];
      this.portfolioList = this.portfolioListForSearch;
    }
  }

  loadPortfolioNameList() {
    this.trade1031Service.GetPortfolioNameList(this.selectedExchange).subscribe(res => {
      this.portfolioNameList = res;
      this.analysisGroup = [];
      this.portfolioGroup = [];
      this.portfolioNameList.forEach(item => {
        let portfolio = {} as PortfolioName;
        portfolio.Id = item.Id;
        portfolio.Name = item.PortfolioName;
        portfolio.Category = item.CategoryId;

        if (item.CategoryId == tables.analysis) {
          this.analysisGroup.push(portfolio);
        }
        else if (item.CategoryId == tables.portfolio) {
          this.portfolioGroup.push(portfolio);
        }
      });
    });
  }

  doAction(event, template: TemplateRef<any>, classes: any,) {
    let count = 0;
    this.listOfExchangeProperties = [];
    this.outputResponse.forEach(items => {
      if (items.IsChecked) {
        count++;
        this.listOfExchangeProperties.push(items.Id);
      }
    });
    if (count == 0 && this.selectedAction !== Actions.Select) {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 property', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else {
      if (this.selectedAction == Actions.Delete) {
        this.openModal(template, classes, 0, count);
      }
    }
    event.target.value = 0;
  }

  clear() {
    this.listOfExchangeProperties = [];
  }
  popupheader = '';
  whereToCreateGroup = 0;
  onGroupCreate(template: TemplateRef<any>, classes: any, whereToCreate) {
    this.whereToCreateGroup = whereToCreate;
    this.groupNameInput = ''
    this.isSubmitGroup = false;
    if (whereToCreate == tables.analysis) {
      this.popupheader = 'Add Analysis Portfolio Group'
    }
    else if (whereToCreate == tables.portfolio) {
      this.popupheader = 'Add My Portfolio Group'
    }
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  editGroupId = 0;
  onGroupEdit(template: TemplateRef<any>, classes: any, whereToCreate, editGroupId, groupName) {
    this.whereToCreateGroup = whereToCreate;
    this.groupNameInput = groupName;
    this.editGroupId = editGroupId;
    this.isSubmitGroup = false;
    if (whereToCreate == tables.analysis) {
      this.popupheader = 'Edit Analysis Portfolio Group'
    }
    else if (whereToCreate == tables.portfolio) {
      this.popupheader = 'Edit My Portfolio Group'
    }
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  isSubmitGroup = false;
  groupNameInput = '';

  onAddGroup() {
    this.isSubmitGroup = true;
    if (!this._ValidationService.IsinValid(this.groupNameInput)) {
      this.portfolioName.PortfolioName = this.groupNameInput;
      this.portfolioName.ExchangeId = this.selectedExchange;
      this.portfolioName.CategoryId = this.whereToCreateGroup;
      this.portfolioName.Id = this.editGroupId;

      this.trade1031Service.SavePortfolioName(this.portfolioName).subscribe(res => {
        if (res.IsSuccess) {
          this.loadPortfolioNameList();
          this.groupNameInput = '';
          this.editGroupId = 0;
          $("#closeModal").click();
        }
        else {
          this.Toast.addToast({ title: 'Error Occurred', msg: res.ErrorMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
      });
    }
  }

  loadExchangeDetails() {
    this.trade1031Service.GetExchangeDetails(this.selectedExchange, this.user.Id).subscribe(res => {
      this.exchangeDetails = res;
      let ProjectedSaleDate = this._ValidationService.convertUTCDateToLocalDate(this.exchangeDetails.ProjectedSaleDate);
      this.exchangeDetails.ExchangeCode = this.exchangeDetails.ExchangeCode + "  " + this._ValidationService.formatDatetoMMDDYYYY(ProjectedSaleDate);
      let SaleDateEnd = this._ValidationService.convertUTCDateToLocalDate(this._ValidationService.addDays(ProjectedSaleDate, 180));
      this.exchangeDetails.ExchangeCode = this.exchangeDetails.ExchangeCode + " - " + this._ValidationService.formatDatetoMMDDYYYY(SaleDateEnd);
    });
  }

  countGroupItems(fromWhere: number, portfolioId: number) {
    if (fromWhere == tables.analysis) {
      return this.analysisGropList.filter(it => {
        return it ? it.PortfolioNameId ? it.PortfolioNameId === portfolioId : false : false;
      }).length;
    }
    else {
      return this.portfolioGropList.filter(it => {
        return it ? it.PortfolioNameId ? it.PortfolioNameId === portfolioId : false : false;
      }).length;
    }
  }

  loadData() {
    this.trade1031Service.GetExchangeProperties(this.selectedExchange).subscribe(res => {
      this.outputResponse = res;
      if (this.outputResponse.length > 0) {
        //this.noDataOnPageLoad = false;
        // this.portfolioListCount = this.outputResponse.length;
      }
      else {
        //this.noDataOnPageLoad = true;
      }
      this.outputResponse.forEach(item => {
        if (item.ListedDate != null) {
          item.ListedDate = this._ValidationService.convertUTCDateToLocalDate(item.ListedDate);
        }
      });
      this.outputResponseFiltered = res;
      this.suggested = [];
      this.wishlist = [];
      this.analysis = [];
      this.portfolio = [];

      this.analysisGropList = [];
      this.portfolioGropList = [];

      this.outputResponse.forEach(item => {
        if (item.GroupId == tables.suggested) {
          this.suggested.push(item);
        }
        else if (item.GroupId == tables.wishlist) {
          this.wishlist.push(item);
        }
        else if (item.GroupId == tables.analysis) {
          if (item.PortfolioNameId == null) {
            this.analysis.push(item);
          }
          else {

            this.analysisGropList.push(item);
          }
        }
        else if (item.GroupId == tables.portfolio && item.OfferPlaced != null && item.OfferPlaced>0) {
          if (item.PortfolioNameId == null) {
            this.portfolio.push(item);
          }
          else {
            this.portfolioGropList.push(item);
          }
        }
      });

      this.suggestedcount = this.suggested.length;
      this.wishlistcount = this.wishlist.length;
      this.portfoliocount = this.portfolio.length;
      this.Loader.display(false);
    });

    this.trade1031Service.GetPlacedOfferProperties(this.selectedExchange).subscribe(res => {
      this.offersResponse = res;
      this.Pendingoffer = [];
      this.OfferAccepted = [];
      this.UnderContract = [];
      this.HardContract = [];
      this.Closed = [];
      this.offersResponse.forEach(item => {
        if (item.StatusId == tables.Pendingoffer) {
          this.Pendingoffer.push(item);
        }
        else if (item.StatusId == tables.OfferAccepted) {
          this.OfferAccepted.push(item);
        }
        else if (item.StatusId == tables.UnderContract) {
          this.UnderContract.push(item);
        }
        else if (item.StatusId == tables.HardContract || item.StatusId == tables.Closed) {
          this.HardContract.push(item);
        }
        //else if (item.StatusId == tables.Closed) {
        //    this.Closed.push(item);
        //}
      });
    });
  }

  getTotalPrice(array: IExchangeProperties[], type: number) {
    let price = 0;
    array.forEach(item => {
      if (item.OfferPlaced != 0 && item.OfferPrice > 0) {
        price += item.OfferPrice;
      }
      else if (type == 1) {
        price += item.Price;
      }
      else {
        price += item.OfferPrice;
      }
    });
    return price;
  }

  Pendingoffer = [];
  OfferAccepted = [];
  UnderContract = [];
  HardContract = [];
  Closed = [];
  onMove(id: number, MoveTo: number) {
    this.Loader.display(true);
    this.StatusInputModel.Id = id;
    this.StatusInputModel.DropTo = MoveTo;
    this.StatusInputModel.loggedInUserID = this.user.Id;
    this.trade1031Service.ChangeExchangePropertyStatus(this.StatusInputModel).subscribe(res => {
      this.Toast.addToast({ title: 'Success', msg: 'Move completed', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      this.isviewAll = true;
      this.loadData();
      this.portfolioTileList.forEach(item => {
        item.isActive = false;
      });
      //this.loadPortfolioTileData();
      this.loadPortfolioList();
      setTimeout(function () { this.Loader.display(false); }, 1000);
    });
  }

  selectAllCheckbox = false;
  onChecked(data) {
    if (data.IsChecked) {
      this.comparePropertiesModel.PropertyIds.push(data.PropertyId);
    }
    else {
      const index: number = this.comparePropertiesModel.PropertyIds.indexOf(data.PropertyId);
      if (index !== -1) {
        this.comparePropertiesModel.PropertyIds.splice(index, 1);
      }
    }

    let checkedCount = 0;
    this.outputResponse.forEach(item => {
      if (item.IsChecked) {
        checkedCount++;
      }
    });
    if (checkedCount === this.outputResponse.length) {
      this.selectAllCheckbox = true;
    }
    else {
      this.selectAllCheckbox = false;
    }
  }

  viewAnalytics(isPropertyAnalysis) {
    if (this.comparePropertiesModel.PropertyIds.length > 1) {
      this.comparisonService.comparePropertiesModelData = this.comparePropertiesModel;
      // this.router.navigate(['/compare']);
      this.comparisonService.isComparePage = true;
      this.isPropertyAnalysis = isPropertyAnalysis;
    }
    else {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Please select at least 2 properties ', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }

  exchangeId = this.selectedExchange;
  viewSuggestProperties(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  onSelectAll() {
    if (this.selectAllCheckbox) {
      this.outputResponse.forEach(item => {
        item.IsChecked = true;
      });
    }
    else {
      this.outputResponse.forEach(item => {
        item.IsChecked = false;
      });
    }
  }
  listOfExchangeProperties = [];
  removeExchangeProperty(id: number) {
    if (id != 0) {
      this.listOfExchangeProperties.push(id);
    }
    this.trade1031Service.RemoveExchangeProperties(this.listOfExchangeProperties, this.user.Id).subscribe(res => {
      if (res) {
        this.loadData();
        this.loadPortfolioList();
        this.loadPortfolioTileData();
        this.Toast.addToast({ title: 'Success', msg: 'Exchange ' + this.popupheading + ' deleted successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Failed to delete exchange ' + this.popupheading + '', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.listOfExchangeProperties = [];
      this.selectAllCheckbox = false;
    });
  }


  propertyToDelete: number;
  openModal(template: TemplateRef<any>, classes: any, id: number, count?: number) {
    if (count > 1) {
      this.popupheading = "Properties";
    }
    else {
      this.popupheading = "Property";
    }
    this.propertyToDelete = id;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  onViewChange(View) {
    this.view = View;
    if (this.currentTile != null && this.view == this.Views.List) {
      this.loadPortfolioList(true);
    }
    else {
      this.loadPortfolioList();
    }
    this.loadData();
    this.selectAllCheckbox = false;
    this.listOfExchangeProperties = [];
    this.searchString = '';
  }
  //this will fire when we drag a property ans set from where it is draging to {currentDragTable}
  onDrag(e: DragEvent, table: number) {
    this.currentDragTable = table;
  }

  // this will fire when we drop a property to any of the tables
  onDrop(e: any, DropTo: number, PortfolioNameId?: number) {
    this.StatusInputModel.Id = e.dragData.Id;
    this.StatusInputModel.DropTo = DropTo;
    this.StatusInputModel.PortfolioNameId = PortfolioNameId;
    this.StatusInputModel.loggedInUserID = this.user.Id;
    this.ChangeStatus(e);
  }

  // call api to change the flags on drop
  ChangeStatus(e: any): void {
    this.trade1031Service.ChangeExchangePropertyStatus(this.StatusInputModel).subscribe(res => {
      if (!res) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Failed to move selected property', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.loadData();
    });
    //if (this.StatusInputModel.DropTo === tables.suggested) {
    //    this.suggested.push(e.dragData);
    //}
    //else if (this.StatusInputModel.DropTo === tables.wishlist) {
    //    this.wishlist.push(e.dragData);
    //}
    //else if (this.StatusInputModel.DropTo === tables.portfolio) {
    //    this.portfolio.push(e.dragData);
    //}
    //this.remove(e);
  }

  // method to move an entire group to another table
  MovePortfolioGroup(PortfolioNameId: number, whereToMove: number) {
    this.MovePortfolioGroupIModel.PortfolioNameId = PortfolioNameId;
    this.MovePortfolioGroupIModel.MoveToGroupId = whereToMove;
    this.trade1031Service.MovePortfolioGroup(this.MovePortfolioGroupIModel).subscribe(res => {
      if (!res) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Failed to move selected group', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.loadPortfolioNameList();
      this.loadData();
    });
  }
  portfolioNameIdToDelete = 0;

  onDeletePortfolioGroupOpenModal(template: TemplateRef<any>, classes: any, portfolioNameId) {
    this.portfolioNameIdToDelete = portfolioNameId;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  DeletePortfolioGroup() {
    this.trade1031Service.DeletePortfolioGroup(this.portfolioNameIdToDelete).subscribe(res => {
      if (res) {
        this.Toast.addToast({ title: 'Success', msg: 'Portfolio Group deleted successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Failed to delete selected group' + this.popupheading + '', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.loadPortfolioNameList();
      this.loadData();
    });
  }

  private remove(e: any) {
    if (this.currentDragTable === tables.wishlist) {
      this.removeItem(e.dragData, this.wishlist);
    }
    else if (this.currentDragTable === tables.portfolio) {
      this.removeItem(e.dragData, this.portfolio);
    }
    else if (this.currentDragTable === tables.analysis) {
      this.removeItem(e.dragData, this.analysis);
    }
    else if (this.currentDragTable === tables.suggested) {
      this.removeItem(e.dragData, this.suggested);
    }
    this.suggestedcount = this.suggested.length;
    this.wishlistcount = this.wishlist.length;
    this.portfoliocount = this.portfolio.length;
    this.analysiscount = this.analysis.length;
  }

  removeItem(item: any, list: Array<any>) {
    let index = list.map(function (e) {
      return e.Id
    }).indexOf(item.Id);
    list.splice(index, 1);
  }
  onClose(close: boolean) {
    if (close) {
      this.modalRef.hide();
      this.loadData();
      this.loadPortfolioList();
      this.loadPortfolioTileData();
    }
  }
  openMessageTab(template: TemplateRef<any>, classes, offerData) {
    var openModelStatus = true;
    offerData.UnReadMessageCount = 0;
    if (openModelStatus) {
      if (offerData.PropertyGuid != "") {
        this.selectedPropertyGuid = offerData.PropertyGuid;
        this.propertyChatModel.ExchangeId = this.exchangeSelected;
        this.propertyChatModel.PropertyGuid = offerData.PropertyGuid;
        this.Shared.clickMessage(this.propertyChatModel);
        //this.modalRef = this.modalService.show(template, { class: classes });
      }
    }
  }

  idToRate: number;
  rating: string[];
  newRating: number;
  starRating: number;
  openStarRatingModal(template: TemplateRef<any>, classes: any, id: number, rating: string[], starRating: number) {

    this.idToRate = id;
    this.rating = rating;
    this.starRating = starRating;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  setStar(data: any, idToRate: number) {
    this.Loader.display(true);
    this.idToRate = idToRate;
    if (data != -1) {
      this.newRating = data + 1;
    }
    else {
      this.newRating = data;
    }
    this.trade1031Service.UpdateExchangePropertyRating(this.idToRate, this.newRating, this.user.Id).subscribe(res => {
      if (res) {
        //this.loadData();
        this.loadPortfolioList(true);
        //this.loadPortfolioTileData();
        this.Toast.addToast({ title: 'Success', msg: 'Property Rating updated successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Failed to update Property rating', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    });
    this.modalRef.hide();
    this.changeRef.detectChanges();
  }

  onArchiveClick() {
    this.Toast.addToast({ title: 'Property Not Available', msg: "The property you are trying to view is not available", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });

  }
}
